import React, { ReactElement, useCallback, useState } from 'react';
import IBroker from '~Api/Broker/IBroker';
import InsuranceExpiryDateModal from './InsuranceExpiryDateModal';
import { CalendarOutlined } from '@ant-design/icons';
import ModalStateEnum from '~UI/ModalStateEnum';

export default function Insurance(props: {
    broker: IBroker;
}): ReactElement {
    const { broker } = props;
    const [isModalOpen, setIsModalOpen] = useState<ModalStateEnum>(ModalStateEnum.Off);

    const onClickCalendar: () => void = useCallback(() => {
        setIsModalOpen(ModalStateEnum.Open);
    }, []);

    const onCloseModal: () => void = useCallback(() => {
        setIsModalOpen(ModalStateEnum.Closed);
    }, []);

    return (
        <>
            <a onClick={onClickCalendar}><CalendarOutlined /></a>
            {ModalStateEnum.Off !== isModalOpen && <InsuranceExpiryDateModal broker={broker} isOpen={isModalOpen} onCancel={onCloseModal} />}
        </>
    );
}